import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading, userPrefPageSize } from '@/decorators';
import { OperatingStatus } from '@/enum';
import AddEditMappingModal from './components/addEditMappingModal.vue';
import ChangeDefaultBodyModal from './components/changeDefaultBodyModal.vue';
import MappingLogModal from './components/mappingLogModal.vue';

var ShopDefaultThemePage = function (_super) {
  __extends(ShopDefaultThemePage, _super);

  function ShopDefaultThemePage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.searchData = _this.initSearchData();
    _this.loadingStatus = false;
    _this.columns = [];
    _this.data = [];
    _this.total = 0;
    _this.bodyList = [];
    _this.countryList = [];
    _this.shopList = [];
    _this.currentRecord = {};
    _this.addEditData = {};
    _this.modeState = OperatingStatus.add;
    return _this;
  }

  ShopDefaultThemePage.prototype.initSearchData = function () {
    return {
      account_code_list: [],
      country_code_list: [],
      shop_code: '',
      shop_name: '',
      page_index: 1,
      page_size: 10
    };
  };

  ShopDefaultThemePage.prototype.handleSearch = function () {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.searchData.page_index = 1;
            return [4, this.queryList()];

          case 1:
            _a.sent();

            return [2];
        }
      });
    });
  };

  ShopDefaultThemePage.prototype.handleClear = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _this = this;

      return __generator(this, function (_a) {
        this.searchData = this.initSearchData();
        this.$nextTick(function () {
          return _this.queryList();
        });
        return [2];
      });
    });
  };

  ShopDefaultThemePage.prototype.handlePageChange = function (page, pageSize) {
    this.searchData.page_index = page;
    this.searchData.page_size = pageSize;
    this.queryList();
  };

  ShopDefaultThemePage.prototype.queryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, resData, _b, _c, list, _d, total;

      return __generator(this, function (_e) {
        switch (_e.label) {
          case 0:
            postData = {
              account_code_list: this.searchData.account_code_list,
              country_code_list: this.searchData.country_code_list,
              shop_code: this.searchData.shop_code,
              shop_name: this.searchData.shop_name,
              page_index: this.searchData.page_index,
              page_size: this.searchData.page_size
            };
            return [4, this.$api.shopManage.queryMappingList(postData)];

          case 1:
            _a = _e.sent().data, resData = _a === void 0 ? {} : _a;
            _b = resData, _c = _b.list, list = _c === void 0 ? [] : _c, _d = _b.total, total = _d === void 0 ? 0 : _d;
            this.data = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  ShopDefaultThemePage.prototype.queryBodyList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.shopManage.getBodyList({})];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? {
              list: []
            } : _a;
            this.bodyList = data.list || [];
            return [2];
        }
      });
    });
  };

  ShopDefaultThemePage.prototype.queryCountryList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.shopManage.getBusinessCountryList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.countryList = Array.isArray(data) ? data : [];
            return [2];
        }
      });
    });
  };

  ShopDefaultThemePage.prototype.queryShopList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, resData, _b, list;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.shopManage.queryList({
              account_code: undefined,
              shop_name: '',
              data_type: this.$enum.common.BoolIntEnum.YES,
              page_index: 1,
              page_size: 200
            })];

          case 1:
            _a = _c.sent().data, resData = _a === void 0 ? {} : _a;
            _b = resData.list, list = _b === void 0 ? [] : _b;
            this.shopList = list || [];
            return [2];
        }
      });
    });
  };

  ShopDefaultThemePage.prototype.handleAdd = function () {
    this.modeState = OperatingStatus.add;
    this.addEditData = {};
    var addEditRef = this.$refs.addEditRef;
    addEditRef.visible = true;
  };

  ShopDefaultThemePage.prototype.handleEdit = function (record) {
    this.modeState = OperatingStatus.edit;
    this.addEditData = __assign({}, record);
    var addEditRef = this.$refs.addEditRef;
    addEditRef.visible = true;
  };

  ShopDefaultThemePage.prototype.handleChangeDefault = function (record) {
    this.currentRecord = __assign({}, record);
    var changeDefaultRef = this.$refs.changeDefaultRef;
    changeDefaultRef.visible = true;
  };

  ShopDefaultThemePage.prototype.handleLog = function (record) {
    this.currentRecord = __assign({}, record);
    var logRef = this.$refs.logRef;
    logRef.visible = true;
  };

  ShopDefaultThemePage.prototype.handleDelete = function (record) {
    var _this = this;

    if (record.is_default === this.$enum.common.BoolIntEnum.YES) {
      this.$warning({
        title: this.t('操作提示'),
        content: this.t('默认主体不可删除，请先变更默认主体再操作'),
        okText: this.t('我知道了')
      });
      return;
    }

    this.$confirm({
      title: this.t('删除'),
      content: this.t('确认删除店铺【{0}】在【{1}】的映射配置？', [record.shop_name, this.formatCountryList(record.country_list)]),
      okType: 'danger',
      okText: this.t('确认删除'),
      onOk: function onOk() {
        return __awaiter(_this, void 0, void 0, function () {
          var code;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4, this.$api.shopManage.deleteMapping({
                  id: record.id
                })];

              case 1:
                code = _a.sent().code;

                if (code === 0) {
                  this.$message.success(this.t('删除成功'));
                  this.queryList();
                }

                return [2];
            }
          });
        });
      }
    });
  };

  ShopDefaultThemePage.prototype.handleSuccess = function () {
    this.queryList();
  };

  ShopDefaultThemePage.prototype.formatCountryList = function (countryList) {
    if (countryList === void 0) {
      countryList = [];
    }

    return (countryList || []).map(function (item) {
      return item.country_code + " " + item.country_name;
    }).join('、');
  };

  ShopDefaultThemePage.prototype.activated = function () {
    this.queryShopList();
  };

  ShopDefaultThemePage.prototype.created = function () {
    this.columns = [{
      title: this.t('店铺编码'),
      dataIndex: 'shop_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('客户代码'),
      dataIndex: 'customer_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('店铺名称'),
      dataIndex: 'shop_name',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('绑定主体'),
      dataIndex: 'bind_body',
      scopedSlots: {
        customRender: 'bind_body'
      }
    }, {
      title: this.t('国家'),
      dataIndex: 'country_list',
      scopedSlots: {
        customRender: 'country'
      }
    }, {
      title: this.t('是否该国默认结算主体'),
      dataIndex: 'is_default',
      scopedSlots: {
        customRender: 'is_default'
      }
    }, {
      title: this.t('操作'),
      width: 220,
      fixed: 'right',
      key: 'operation',
      scopedSlots: {
        customRender: 'operation'
      }
    }];
    this.queryList();
    this.queryBodyList();
    this.queryCountryList();
  };

  __decorate([userPrefPageSize('shopMappingList')], ShopDefaultThemePage.prototype, "initSearchData", null);

  __decorate([loading('loadingStatus')], ShopDefaultThemePage.prototype, "queryList", null);

  ShopDefaultThemePage = __decorate([Component({
    components: {
      AddEditMappingModal: AddEditMappingModal,
      ChangeDefaultBodyModal: ChangeDefaultBodyModal,
      MappingLogModal: MappingLogModal
    }
  })], ShopDefaultThemePage);
  return ShopDefaultThemePage;
}(Vue);

export default ShopDefaultThemePage;